export default "__VITE_ASSET__BxgE4135__"